// @flow
import React from 'react';
import {
  MdMap,
  MdSchool,
  MdDirections,
} from 'react-icons/lib/md';

import type { ID_TYPE } from '../../types/common';
import NotificationElementDummy from '../NotificationElementDummy';
import {
  DEPARTURE,
  COMPLETION,
  DIRECT_MESSAGE,
} from './types';


type NotificationElementPropTypes = {
  id: ID_TYPE,
  title: string,
  date: string,
  isRead: boolean,
  notificationType: string,
  onSelect?: ID_TYPE => void
};

const NotificationElement = ({
  id,
  title,
  date,
  isRead,
  notificationType,
  onSelect,
}: NotificationElementPropTypes) => {
  // TODO: COMPLETAR TODOS LOS CASOS E ICONOS

  let IconResult = MdSchool;
  switch (notificationType) {
    case DEPARTURE: {
      IconResult = MdDirections;
      break;
    }
    case COMPLETION: {
      IconResult = MdMap;
      break;
    }
    case DIRECT_MESSAGE: {
      IconResult = MdDirections;
      break;
    }
    default: {
      IconResult = MdDirections;
      break;
    }
  }

  //
  return (
    <NotificationElementDummy
      pictureURL={undefined /* TODO: extraer esta imagen del usurio que creo la notificación */}
      title={title}
      // description={ notification.description }
      date={date}
      onSelect={() => onSelect && onSelect(id)}
      isRead={isRead}
    />);
};

export default NotificationElement;



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationElement/index.jsx